module.exports = __webpack_public_path__ + "static/kokowinka-bb1f354ef98899a18555b8508efd966c.png";